import {
    CHANGE_SIM_PROVIDER_REQUEST,
    CHANGE_SIM_PROVIDER_RESULT,
    CHANGE_SIM_PROVIDER_OPEN_MODAL,
    CHANGE_SIM_PROVIDER_CLOSE_MODAL,
    CHANGE_SIM_PROVIDER_GET_DEVICE_REQUEST,
    CHANGE_SIM_PROVIDER_GET_DEVICE_RESULT,
    CHANGE_SIM_PROVIDER_SET_DEVICE,
} from 'Redux/actionTypes';

export const changeSimProviderRequest = (data) => ({
    type: CHANGE_SIM_PROVIDER_REQUEST,
    payload: data
})

export const changeSimProviderResult = (result) => ({
    type: CHANGE_SIM_PROVIDER_RESULT,
    payload: result
})

export const changeSimProviderOpenModal = (items) => ({
    type: CHANGE_SIM_PROVIDER_OPEN_MODAL,
    payload: items
})

export const changeSimProviderCloseModal = () => ({
    type: CHANGE_SIM_PROVIDER_CLOSE_MODAL
})

export const changeSimProviderGetDeviceRequest = (item) => ({
    type: CHANGE_SIM_PROVIDER_GET_DEVICE_REQUEST,
    payload: item
})

export const changeSimProviderGetDeviceResult = (result) => ({
    type: CHANGE_SIM_PROVIDER_GET_DEVICE_RESULT,
    payload: result
})

export const changeSimProviderSetDevice = (device) => ({
    type: CHANGE_SIM_PROVIDER_SET_DEVICE,
    payload: device
})